import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { getPostBySlug } from '../data/posts';
import { useTranslation } from '../context/TranslationContext';
import useDocumentTitle from '../hooks/useDocumentTitle';

function formatDate(iso, lang) {
  return new Date(iso).toLocaleDateString(lang === 'en' ? 'en-GB' : 'es-ES', {
    day: 'numeric', month: 'long', year: 'numeric',
  });
}

const COPY = {
  es: {
    home: 'Inicio',
    notebook: 'Cuaderno',
    read: 'de lectura',
    notFound: 'No encontramos este artículo.',
    notFoundBody: 'Puede que haya cambiado de dirección.',
    seeAll: 'Ver todo el cuaderno',
    pending: 'Este artículo aún no está publicado en este idioma.',
    endTitle: '¿Os suena lo que habéis leído?',
    endCta: 'Escribirnos',
    back: 'Volver al cuaderno',
  },
  en: {
    home: 'Home',
    notebook: 'Notebook',
    read: 'read',
    notFound: "We can't find this article.",
    notFoundBody: 'It may have moved.',
    seeAll: 'See the whole notebook',
    pending: "This article isn't published in this language yet.",
    endTitle: 'Does this sound familiar?',
    endCta: 'Write to us',
    back: 'Back to the notebook',
  },
};

export default function BlogPost() {
  const { slug } = useParams();
  const post = getPostBySlug(slug);
  const { lang } = useTranslation();
  const c = COPY[lang] || COPY.es;
  const data = post ? post[lang] || post.es : null;

  useDocumentTitle(`${data ? data.title : c.notFound} · Qyntix`);

  if (!post) {
    return (
      <main id="main" className="article">
        <div className="wrap">
          <div className="article-inner">
            <h1>{c.notFound}</h1>
            <p className="t-lead">{c.notFoundBody}</p>
            <p style={{ marginTop: 32 }}><Link to="/blog" className="link">{c.seeAll}</Link></p>
          </div>
        </div>
      </main>
    );
  }

  return (
    <main id="main" className="article">
      <div className="wrap">
        <div className="article-inner">
          <nav className="crumbs t-small" aria-label="Breadcrumb">
            <Link to="/">{c.home}</Link>
            <span aria-hidden="true">/</span>
            <Link to="/blog">{c.notebook}</Link>
          </nav>

          <p className="t-small">{data.category}</p>
          <h1>{data.title}</h1>

          <div className="article-meta t-small">
            <time className="mono" dateTime={post.date}>{formatDate(post.date, lang)}</time>
            <span className="mono">{post.readTime} {c.read}</span>
          </div>

          {data.content
            ? <article className="prose" dangerouslySetInnerHTML={{ __html: data.content }} />
            : <p className="t-lead">{c.pending}</p>}

          <aside className="post-end">
            <p className="t-2">{c.endTitle}</p>
            <a href="/#contacto" className="btn">{c.endCta}</a>
          </aside>

          <p style={{ marginTop: 40 }}><Link to="/blog" className="link">{c.back}</Link></p>
        </div>
      </div>
    </main>
  );
}
